// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clickable[data-v-4048153a]{cursor:pointer}.item-row[data-v-4048153a]{background-color:#fafbfc}.order-item-thumbnail[data-v-4048153a]{width:40px;height:40px;overflow:hidden}.placeholder-thumb.small[data-v-4048153a]{width:40px;height:40px;background-color:#e9ecef;border-radius:4px}", ""]);
// Exports
module.exports = exports;
